import { createSelector } from 'reselect';
import { ApplicationState } from '../types';

export const getSellDeliveryMethod = ({
  sellDeliveryMethod,
}: ApplicationState) => sellDeliveryMethod;

export const getSelectedDeliveryMethod = createSelector(
  [getSellDeliveryMethod],
  (sellDeliveryMethod) => sellDeliveryMethod?.deliveryMethod || ''
);

export const getDeliveryMethod = createSelector(
  [getSellDeliveryMethod],
  (sellDeliveryMethod) => sellDeliveryMethod?.deliveryMethod
);
